/**
 * Map scoreboard / market short labels (e.g. KKR, IND) to full franchise names used for
 * cricket logo / headshot lookups, using fixture title teams as the candidate pool.
 */

function normalizeTeamKey(value?: string): string {
    return String(value || "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
}

function cricketTeamAbbreviation(teamName: string): string {
    const words = String(teamName || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    if (words.length === 0) return "";
    if (words.length === 1) {
        return words[0]!.replace(/[^A-Za-z0-9]/g, "").slice(0, 3).toUpperCase();
    }
    return words
        .map((w) => w.replace(/[^A-Za-z0-9]/g, ""))
        .filter(Boolean)
        .map((w) => w[0]!)
        .join("")
        .slice(0, 3)
        .toUpperCase();
}

function abbrevAppearsAsDistinctToken(text: string, abbr: string): boolean {
    const a = String(abbr || "").trim();
    if (a.length < 2) return false;
    const escaped = a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    try {
        return new RegExp(`\\b${escaped}\\b`, "i").test(String(text || ""));
    } catch {
        return false;
    }
}

export function resolveCricketTeamNameForLogo(label: string, candidatePool: string[]): string {
    const raw = String(label ?? "").trim();
    if (!raw) return "";

    const pool = (candidatePool || []).map((t) => String(t ?? "").trim()).filter(Boolean);
    if (pool.length === 0) return raw;

    for (const cand of pool) {
        if (raw === cand) return cand;
        if (raw.toLowerCase() === cand.toLowerCase()) return cand;
    }

    const rawKey = normalizeTeamKey(raw);
    for (const cand of pool) {
        const candKey = normalizeTeamKey(cand);
        if (!rawKey || !candKey) continue;
        if (rawKey === candKey) return cand;
        if (rawKey.includes(candKey) || candKey.includes(rawKey)) return cand;
    }

    const rawUpper = raw.toUpperCase();
    for (const cand of pool) {
        const abbr = cricketTeamAbbreviation(cand);
        if (abbr.length >= 2 && (rawUpper === abbr || abbrevAppearsAsDistinctToken(raw, abbr))) {
            return cand;
        }
    }

    return raw;
}
